import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import {
  edupali,
  edupaliLanding,
  elipse,
  rectStroke,
} from "../../../../assets/exports";
import Wrapper from "../../../common/Wrapper";

const FifthLayer = () => {
  return (
    <Wrapper>
      <Box
        pos="relative"
        mt="100px"
        pt={{ base: "52px", md: "100px" }}
        bgColor="#7B47CC"
        textAlign="center"
        color="#ffff"
        px="20px"
      >
        <Image pos="absolute" right={0} top={0} src={elipse} />
        <Text
          pb="6px"
          fontSize={["24px", "24px", "24px", "40px"]}
          fontWeight={500}
        >
          Introducing
        </Text>
        <Heading fontSize={["24px", "24px", "30px", "40px"]}>
          <span style={{ position: "relative", paddingRight: "5px" }}>
            EduPali:
            <Image
              pos="absolute"
              width={{ base: "70px", md: "auto" }}
              left={0}
              src={rectStroke}
            />
          </span>
          Simplifying School Payments
        </Heading>
        <Text
          pt={{ base: "21px", md: "50px" }}
          color="#B5C2D6"
          maxW="1000px"
          mx="auto"
          fontSize={["14px", "18px", "20px"]}
        >
          EduPali is a comprehensive platform designed to address the challenges
          associated with managing school fees for Educational Institutions.
          Edupali automates end-to-end payment processes, reducing
          administrative burdens, ensuring adequate accountability, and
          facilitating seamless transactions for educational institutions.
          Edupali provides flexible payment options for learners, enhancing
          access to learning through simplified fee payments and boosting
          payment compliance rates.
        </Text>
        <Flex
          gap={{ base: "11px", md: "1rem" }}
          justifyContent="center"
          pt="2rem"
          px="2rem"
          // display={"none"}
        >
          <Link
            target="_blank"
            href="https://www.edupali.com/"
            isExternal
            height={{ base: "49px", md: "68px" }}
            // w="211px"
          >
            <Button
              // w="211px"
              w={[" 153px", "211px"]}
              bgGradient="linear(to-r, #377DFF, #2463EB)"
              color="white"
              borderRadius="12px"
              boxShadow="md"
              _hover={{ bgGradient: "linear(to-r, #377DFF, #2463EB)" }}
              _active={{ transform: "scale(0.98)", boxShadow: "sm" }}
              _focus={{ boxShadow: "outline" }}
              px="28px"
              height={{ base: "49px", md: "68px" }}
              fontSize={{ base: "14px", md: "20px" }}
              fontWeight={500}
            >
              Explore Product
            </Button>
          </Link>
          <Link
            target="_blank"
            href="https://www.school.edupali.com/register-step-1"
            isExternal
          >
            <Button
              w={[" 153px", "211px"]}
              bg="transparent"
              border="2px solid #fff"
              color="white"
              borderRadius="12px"
              boxShadow="md"
              px="28px"
              height={{ base: "49px", md: "68px" }}
              fontSize={{ base: "14px", md: "20px" }}
              fontWeight={500}
            >
              Sign Up
            </Button>
          </Link>
        </Flex>
        <Flex
          flexDir="column"
          pt="24px"
          justifyContent="center"
          maxW="1110px"
          mx="auto"
        >
          <Flex justifyContent="flex-end">
            <Image w={{ base: "65px", md: "145px" }} src={edupali} />
          </Flex>
          <Box>
            <Image mx="auto" src={edupaliLanding} />
          </Box>
        </Flex>
      </Box>
    </Wrapper>
  );
};

export default FifthLayer;
